import { createSlice } from '@reduxjs/toolkit';

interface InitialStateProps {
  list: {
    isLoading: boolean;
    data: Record<string, any>[] | null;
    error: string | null;
  };
}

const initialState: InitialStateProps = {
  list: {
    isLoading: false,
    error: null,
    data: null,
  },
};

export const { actions: faqActions, reducer: faqReducer } = createSlice({
  name: 'faq',
  initialState,
  reducers: {
    setFaqRequest: (state) => {
      state.list = {
        isLoading: true,
        data: null,
        error: null,
      };
    },

    setFaqSuccess: (state, { payload }) => {
      state.list = {
        isLoading: false,
        data: payload.hits,
        error: null,
      };
    },

    setFaqFailure: (state, { payload }) => {
      state.list = {
        isLoading: false,
        data: null,
        error: payload.message,
      };
    },
  },
});
